import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { proxyApi, useValidatorStore, userValidator } from '@features/proxy';
import { pageRedirects, useLoginInfoStore } from '@features/shared';

const statusHandling = {
  pending: 'pending',
  'emp-pending': 'emp-pending',
  disabled: 'disabled',
  deactive: 'disabled',
};

export const ValidateApprovalStatus = () => {
  const [searchParams] = useSearchParams();

  const { userInfo } = useLoginInfoStore();
  const { setValidateStep } = useValidatorStore();

  const validateApprovalStatus = useCallback(async () => {
    const channel = searchParams.get('channel') || 'btp';
    const channels = userInfo.data?.channels || {};
    const status = channels[channel]?.approvalStatus ?? '';

    const { isAdUser } = userValidator;

    switch (status) {
      case 'approved':
      case 'inactive': {
        await proxyApi.setAccountStatus({ uid: userInfo.UID ?? '', channel });
        return setValidateStep('consent-check');
      }
      case 'pending':
      case 'emp-pending':
      case 'disabled':
      case 'deactive': {
        return pageRedirects.approvalStatusError(statusHandling[status]);
      }
      default: {
        if (isAdUser(userInfo)) return pageRedirects.newChannelAd({ uid: userInfo.UID ?? '', channel });
        return pageRedirects.channelExpand({ uid: userInfo.UID ?? '', channel: channel });
      }
    }
  }, [searchParams, userInfo, setValidateStep]);

  useEffect(() => {
    console.log('validate approval status');
    validateApprovalStatus();
  }, [validateApprovalStatus]);

  return null;
};
